export const common = {
  uk: {
    my_location: 'Моє місцезнаходження',
    price_per_car: 'ціна за авто',
    passengers: 'пасажирів',
    child_seat: 'дитяче крісло',
    luggage: 'багажу',
    book: 'Забронювати',
    previous: 'Попередня',
    next: 'Наступна',
    creating_order: 'Створюється замовлення...',
    modal_passengers_title: 'Пасажири й багаж',
    modal_passengers_label: 'Пасажири',
    modal_passengers_hint: 'Вкажіть загальну кількість людей.',
    modal_luggage_label: 'Одиниці багажу',
    modal_luggage_hint: 'Валізи або великі сумки.',
    modal_cancel_btn: 'Скасувати',
    modal_continue_btn: 'Продовжити',
    modal_error_passengers: 'Вкажіть мінімум 1 пасажира.',
    modal_error_luggage: 'Кількість багажу не може бути від’ємною.',
    modal_saved_status: 'Збережено. Продовжуємо...',
    flight_number_required: 'Потрібно вказати номер рейсу.',
  },
  en: {
    my_location: 'My location',
    price_per_car: 'price per car',
    passengers: 'pax',
    child_seat: 'child seat',
    luggage: 'luggage',
    book: 'Book',
    previous: 'Previous',
    next: 'Next',
    creating_order: 'Creating order...',
    modal_passengers_title: 'Passengers & Luggage',
    modal_passengers_label: 'Passengers',
    modal_passengers_hint: 'Enter total number of people traveling.',
    modal_luggage_label: 'Luggage items',
    modal_luggage_hint: 'Suitcases or large bags.',
    modal_cancel_btn: 'Cancel',
    modal_continue_btn: 'Continue',
    modal_error_passengers: 'Please enter at least 1 passenger.',
    modal_error_luggage: 'Luggage count cannot be negative.',
    modal_saved_status: 'Saved. Continuing...',
    flight_number_required: 'Flight number is required.',
  },
  cs: {
    my_location: 'Moje poloha',
    price_per_car: 'cena za auto',
    passengers: 'osob',
    child_seat: 'dětská sedačka',
    luggage: 'zavazadla',
    book: 'Rezervovat',
    previous: 'Předchozí',
    next: 'Další',
    creating_order: 'Vytváří se objednávka...',
    modal_passengers_title: 'Cestující a zavazadla',
    modal_passengers_label: 'Cestující',
    modal_passengers_hint: 'Zadejte celkový počet cestujících.',
    modal_luggage_label: 'Kusy zavazadel',
    modal_luggage_hint: 'Kufry nebo velké tašky.',
    modal_cancel_btn: 'Zrušit',
    modal_continue_btn: 'Pokračovat',
    modal_error_passengers: 'Zadejte alespoň 1 cestujícího.',
    modal_error_luggage: 'Počet zavazadel nemůže být záporný.',
    modal_saved_status: 'Uloženo. Pokračujeme...',
    flight_number_required: 'Je vyžadováno číslo letu.',
  },
  de: {
    my_location: 'Mein Standort',
    price_per_car: 'Preis pro Auto',
    passengers: 'Personen',
    child_seat: 'Kindersitz',
    luggage: 'Gepäck',
    book: 'Buchen',
    creating_order: 'Bestellung wird erstellt...',
    modal_passengers_title: 'Passagiere & Gepäck',
    modal_passengers_label: 'Passagiere',
    modal_passengers_hint: 'Gesamtzahl der Reisenden eingeben.',
    modal_luggage_label: 'Gepäckstücke',
    modal_luggage_hint: 'Koffer oder große Taschen.',
    modal_cancel_btn: 'Abbrechen',
    modal_continue_btn: 'Weiter',
    modal_error_passengers: 'Bitte geben Sie mindestens 1 Passagier ein.',
    modal_error_luggage: 'Gepäckanzahl kann nicht negativ sein.',
    modal_saved_status: 'Gespeichert. Weiter...',
    flight_number_required: 'Flugnummer erforderlich.',
  },
  fr: {
    my_location: 'Ma position',
    price_per_car: 'prix par voiture',
    passengers: 'passagers',
    child_seat: 'siège enfant',
    luggage: 'bagages',
    book: 'Réserver',
    creating_order: 'Création de commande...',
    modal_passengers_title: 'Passagers et bagages',
    modal_passengers_label: 'Passagers',
    modal_passengers_hint: 'Indiquez le nombre total de personnes.',
    modal_luggage_label: 'Articles de bagage',
    modal_luggage_hint: 'Valises ou grands sacs.',
    modal_cancel_btn: 'Annuler',
    modal_continue_btn: 'Continuer',
    modal_error_passengers: 'Veuillez entrer au moins 1 passager.',
    modal_error_luggage: 'Le nombre de bagages ne peut pas être négatif.',
    modal_saved_status: 'Enregistré. On continue...',
    flight_number_required: 'Le numéro de vol est requis.',
  },
  es: {
    my_location: 'Mi ubicación',
    price_per_car: 'precio por coche',
    passengers: 'pasajeros',
    child_seat: 'asiento infantil',
    luggage: 'equipaje',
    book: 'Reservar',
    creating_order: 'Creando pedido...',
    modal_passengers_title: 'Pasajeros y equipaje',
    modal_passengers_label: 'Pasajeros',
    modal_passengers_hint: 'Introduzca el número total de personas.',
    modal_luggage_label: 'Bultos de equipaje',
    modal_luggage_hint: 'Maletas o bolsas grandes.',
    modal_cancel_btn: 'Cancelar',
    modal_continue_btn: 'Continuar',
    modal_error_passengers: 'Introduce al menos 1 pasajero.',
    modal_error_luggage: 'El número de equipaje no puede ser negativo.',
    modal_saved_status: 'Guardado. Continuando...',
    flight_number_required: 'Se requiere el número de vuelo.',
  },
  zh: {
    my_location: '我的位置',
    price_per_car: '每辆车价格',
    passengers: '乘客',
    child_seat: '儿童座椅',
    luggage: '行李',
    book: '预订',
    creating_order: '正在创建订单...',
    modal_passengers_title: '乘客与行李',
    modal_passengers_label: '乘客',
    modal_passengers_hint: '请输入出行人数总计。',
    modal_luggage_label: '行李件数',
    modal_luggage_hint: '手提箱或大包。',
    modal_cancel_btn: '取消',
    modal_continue_btn: '继续',
    modal_error_passengers: '请输入至少 1 位乘客。',
    modal_error_luggage: '行李数量不能为负数。',
    modal_saved_status: '已保存，继续...',
    flight_number_required: '需要填写航班号。',
  },
  ru: {
    my_location: 'Моё местоположение',
    price_per_car: 'цена за авто',
    passengers: 'пассажиров',
    child_seat: 'детское кресло',
    luggage: 'багажа',
    book: 'Забронировать',
    creating_order: 'Создается заказ...',
    modal_passengers_title: 'Пассажиры и багаж',
    modal_passengers_label: 'Пассажиры',
    modal_passengers_hint: 'Укажите общее количество человек.',
    modal_luggage_label: 'Единицы багажа',
    modal_luggage_hint: 'Чемоданы или большие сумки.',
    modal_cancel_btn: 'Отмена',
    modal_continue_btn: 'Продолжить',
    modal_error_passengers: 'Введите минимум 1 пассажира.',
    modal_error_luggage: 'Количество багажа не может быть отрицательным.',
    modal_saved_status: 'Сохранено. Продолжаем...',
    flight_number_required: 'Требуется номер рейса.',
  },
};
